import React, { useState, useEffect } from "react";
import Charts from "./base";
import setPropsByKeyPath from "../../utils/setPropsByKeyPath";
import copy from "../../utils/copy";
const defaultData = [
  ["系列", "2015", "2016", "2017"],
  ["名称2", 43.3, 85.8, 93.7],
  ["名称3", 83.1, 73.4, 55.1],
  ["名称4", 86.4, 65.2, 82.5],
  ["名称5", 72.4, 53.9, 39.1],
];

const updateSeries = (series, data) => {
  const [row] = data || [];
  if (!row) return series;
  if (row.length < 2) return series;
  const [ser] = series;
  if (!ser) return series;
  // 去掉第一个单元
  let ns = [];
  row.slice(1).map((d, i) => {
    let s = series[i] || copy(ser);
    s.name = d;
    ns[i] = s;
  });
  //只有一个系列不能有stack属性不然报错
  if (ns.length === 1 && ns[0].stack){
    //echart报错，自行定义option
    delete ns[0].stack;
  }
  return ns;
};
const combineSource = (source, extSource) => {
  if (!extSource || !extSource.length) return source;
  let res = copy(source);
  extSource.map((data) => {
    data.map((row, i) => {
      if (!res[i]) return;
      let r = res[i];
      res[i] = r.concat(row.slice(1));
    });
  });
  return res;
};

export default (elmprops) => {
  const { id, className, style, props, defaultOption, theme } = elmprops;
  const [data, setData] = useState();
  let option = setPropsByKeyPath(defaultOption, props);
  if (!option.dataset) {
    let source = props["dataConfig.staticData"] || defaultData;
    option.dataset = {
      source: source,
    };
  } else if (data) {
    option.dataset.source = data;
  }
  updateSeries(option.series, option.dataset.source);
  useEffect(() => {
    if (
      !props["dataset.extSource"] ||
      !props["dataset.source"] ||
      !props["dataset.extSource"].length ||
      !props["dataset.source"].length
    )
      return;
    setData(combineSource(props["dataset.source"], props["dataset.extSource"]));
  }, [props["dataset.extSource"]]);
  return <Charts id={id} option={option} style={style} className={className} theme={theme}/>;
};
